import React from 'react';
import ReactDOM from 'react-dom/client'; // Use the updated API for React 18
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { CartProvider } from './context/CartContext';

// Get the root element
const rootElement = document.getElementById('root');

// Create a root
const root = ReactDOM.createRoot(rootElement);

// Fallback client ID for local development
const googleClientId = process.env.REACT_APP_CLIENT_ID || "test-client-id-for-local-development";

// Debug: Log the Google Client ID to verify it's loaded correctly
console.log('Google Client ID:', process.env.REACT_APP_CLIENT_ID);
console.log('Using Google Client ID:', googleClientId);

// Render the app
root.render(
  // <React.StrictMode>
    <GoogleOAuthProvider clientId={googleClientId}>
      <CartProvider>
        <App />
      </CartProvider>
    </GoogleOAuthProvider>
  // </React.StrictMode>
);

// Optional: Report web vitals
reportWebVitals();
